import { render, staticRenderFns } from "./ExportRequestsHead.vue?vue&type=template&id=08e77756&scoped=true"
import script from "./ExportRequestsHead.vue?vue&type=script&lang=js"
export * from "./ExportRequestsHead.vue?vue&type=script&lang=js"
import style0 from "./ExportRequestsHead.vue?vue&type=style&index=0&id=08e77756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e77756",
  null
  
)

export default component.exports